"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PTxInfo = void 0;
var pstruct_1 = require("../../../../PTypes/PStruct/pstruct.js");
var PTxInInfo_1 = require("../../Tx/PTxInInfo.js");
var PTxOut_1 = require("../../Tx/PTxOut.js");
var type_system_1 = require("../../../../type_system/index.js");
var PValue_1 = require("../../../V1/Value/PValue/index.js");
var PDCert_1 = require("../../../V1/PDCert/index.js");
var PStakingCredential_1 = require("../../../V1/Address/PStakingCredential.js");
var Time_1 = require("../../../V1/Time/index.js");
var PPubKeyHash_1 = require("../../../V1/PubKey/PPubKeyHash.js");
var PScriptPurpose_1 = require("../../../V1/ScriptContext/PScriptPurpose/index.js");
var PDatumHash_1 = require("../../../V1/ScriptsHashes/PDatumHash.js");
var PTxId_1 = require("../../../V1/Tx/PTxId.js");
exports.PTxInfo = (0, pstruct_1.pstruct)({
    PTxInfo: {
        inputs: (0, type_system_1.list)(PTxInInfo_1.PTxInInfo.type),
        refInputs: (0, type_system_1.list)(PTxInInfo_1.PTxInInfo.type),
        outputs: (0, type_system_1.list)(PTxOut_1.PTxOut.type),
        fee: PValue_1.PValue.type,
        mint: PValue_1.PValue.type,
        dCertificates: (0, type_system_1.list)(PDCert_1.PDCert.type),
        withdrawals: (0, type_system_1.list)((0, type_system_1.pair)(PStakingCredential_1.PStakingCredential.type, type_system_1.int)),
        interval: Time_1.PPOSIXTimeRange.type,
        signatories: (0, type_system_1.list)(PPubKeyHash_1.PPubKeyHash.type),
        redeemers: (0, type_system_1.list)((0, type_system_1.pair)(PScriptPurpose_1.PScriptPurpose.type, type_system_1.data)),
        datums: (0, type_system_1.list)((0, type_system_1.pair)(PDatumHash_1.PDatumHash.type, type_system_1.data)),
        id: PTxId_1.PTxId.type
    }
});
